import { HttpClient } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";

@Injectable()
export class IncidentDeletedItemsService {
    private httpClient: HttpClient = inject(HttpClient);
    private baseUrl = `${localStorage.getItem("incidentUrl")}/api/deleted-items`;

    public getDeletedItems(): Observable<any> {
        return this.httpClient.get<any>(`${this.baseUrl}`);
    }

    public restoreDeletedItem(identifier: number): Observable<any> {
        return this.httpClient.post<any>(`${this.baseUrl}/${identifier}/restore`, {});
    }
}
